import type { AreaDefinition } from '@/world/area';

/**
 * Katie's cottage.
 *
 * Small on purpose: a single room that reads at a glance, with the bed and the
 * door on opposite sides so waking up and heading out is one clean movement.
 *
 * Legend: W wall  F floor  R rug  B bed  D doormat
 */
export const COTTAGE_AREA: AreaDefinition = {
  id: 'cottage',
  name: 'Cottage',
  indoor: true,
  rows: [
    'WWWWWWWWWWWWWW',
    'WBFFFFFFFFFFFW',
    'WFFFFFFFFFFFFW',
    'WFFFFFFFFFFFFW',
    'WFFFFRRRRFFFFW',
    'WFFFFRRRRFFFFW',
    'WFFFFFFFFFFFFW',
    'WFFFFFFFFFFFFW',
    'WFFFFFFFFFFFFW',
    'WWWWWWDDWWWWWW',
  ],
  spawn: { x: 2 * 16, y: 2 * 16 },
  // Katie did not arrive to an empty room. Everything here can be picked up
  // and moved, so the first decorating is rearranging rather than shopping.
  furniture: [
    { id: 'table', x: 9, y: 2 },
    { id: 'chair', x: 9, y: 3 },
    { id: 'plantPot', x: 1, y: 8 },
    { id: 'bookshelf', x: 11, y: 6 },
  ],
  bed: { x: 1, y: 1 },
  // Both doormat tiles lead out, onto the path below the cottage door — one
  // tile clear of the farm's own portal, so stepping out does not bounce
  // straight back in.
  portals: [
    { x: 6, y: 9, toArea: 'farm', toX: 7, toY: 8 },
    { x: 7, y: 9, toArea: 'farm', toX: 7, toY: 8 },
  ],
};
